<mat-form-field floatLabel="always" class="custom-mat-form-field size size1of1">
    <mat-label>Rate plan template</mat-label>
    <input type="text" placeholder="Pick one" aria-label="Number" matInput [formControl]="myControl"
        [matAutocomplete]="auto">
    <mat-autocomplete (optionSelected)="onSelectTemplate($event)" autoActiveFirstOption #auto="matAutocomplete"
        [displayWith]="displayFn">
        <mat-option *ngIf="!hideNew" class="new-plan-option">Create a New Plan</mat-option>
        <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
            {{option.name}}
        </mat-option>
    </mat-autocomplete>
</mat-form-field>
